import { validator } from "LIB/validate-this";
import { CONDITION, LEAD_TIME, PART_ID } from "MODULES/inventories/constants";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import * as rules from "LIB/validation/rules";
import { COST, QUANTITY } from "APP_ROOT/constants";
import { STANDARD } from "MODULES/IncomingQuotes/constants";

export default function validate(values) {
  return validator(values, form => {
    form.validate(PART_ID).satisfies(rules.required);

    if (values.quote_type === STANDARD) {
      form
        .validate(CONDITION, COST, QUANTITY, QUOTE_TYPE, LEAD_TIME)
        .satisfies(rules.required);
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RequiredComponents/validate.js